import { Box, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import CustomBreadcrumbs from "../../components/CustomBreadcrumbs/CustomBreadcrumbs";
import {
  digiGoldTitle,
  digiSilverTitle,
  recentTransactionsText,
} from "../../utils/constants";
import { useAppSelector } from "../../redux-store/CustomReduxHooks";
import { T_DigiHoldingsResponseObject } from "./Feature_ABCD_Types";
import { CustomDigiItemRecentTransactions } from "../../components/CustomABCDHoldingItems/CustomDigiItemRecentTransactions";

export const ViewAllTransactionsPage: FC = () => {
  const { state } = useLocation();
  const [apiData, setApiData] = useState<
    T_DigiHoldingsResponseObject | undefined
  >(undefined);
  const digiGoldData = useAppSelector(
    (state) => state.ABCDHoldingsSlice.digiGoldData,
  );
  const digiSilverData = useAppSelector(
    (state) => state.ABCDHoldingsSlice.digiSilverData,
  );

  useEffect(() => {
    if (state === digiGoldTitle) {
      setApiData(digiGoldData);
    } else {
      setApiData(digiSilverData);
    }
  }, [state, digiGoldData, digiSilverData]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      paddingRight="1rem"
      paddingLeft="1rem"
      marginTop="2rem"
      gap="1.5rem"
    >
      <Box
        display="flex"
        alignItems="center"
        gap={{ sm: 10 }}
        sx={{ justifyContent: "flex-start" }}
        className="bread-crumbs"
      >
        <CustomBreadcrumbs
          data={[
            state === digiGoldTitle ? digiGoldTitle : digiSilverTitle,
            "....",
            recentTransactionsText,
          ]}
        />
      </Box>

      <Box gap="1rem">
        {/* Map through dgTransaction */}
        {apiData?.dgTransanctions?.map((transaction, index) => (
          <>
            <>
              <CustomDigiItemRecentTransactions transaction={transaction} />
            </>
            <Box height=".0625rem" bgcolor="#E6E6E6"></Box>
          </>
        ))}
      </Box>
    </Box>
  );
};
